<form [formGroup]="addPassportForm">
    <div class="f-row custom-dialog">
        <div class="container">
            <div class="verify-title">
                <div class="title">
                    <h3 class="title-text">{{content?.['b2b.managetraveler.editdocdetails']}}</h3>
                    <span class="sub-title">{{content?.['b2b.managetraveler.enteralldetails']}}</span>
                </div>
                <div class="close">
                    <mat-icon fontSet="material-symbols-outlined" aria-label="close button" tabindex="0" role="button"
                        (keydown.enter)="CloseDialog()" (keyup.space)="CloseDialog()" class="close"
                        (click)="CloseDialog()">close</mat-icon>
                </div>
            </div>

            <div class="f-col verify-body">
                <div class="form-info-section" [class.view-disabled]="Loader.isEditableClicked">
                    <div class="f-row two--ColLayout">
                        <div class="f-col">
                            <ng-select autoBlurSelect [items]="countriesLists" groupBy="group"
                                [searchFn]="_CommonService.customCountrySearchFn" formControlName="countryControl0"
                                bindValue="isoCode" placeholder="Nationality"
                                (keypress)="_CommonService.blockInvalidCharacters($event)"
                                (paste)="_CommonService.onPasteBlocked($event)"
                                (contextmenu)="_CommonService.disableRightClick($event)">
                                <ng-template ng-optgroup-tmp let-item="item"> {{ item.group }} </ng-template>
                                <ng-template ng-option-tmp let-item="item">
                                    <span class="ng-option-label">
                                        <ng-container *ngIf="!!item?.newFlag?.src">
                                            <img [src]="getImageUrl(item?.newFlag?.src)"
                                                alt="Flag of {{ item.countryName }}" class="flag-img"
                                                [height]="item.height" [width]="item.width" />
                                        </ng-container>
                                        {{ item.countryName }}
                                    </span>
                                </ng-template>
                                <ng-template ng-label-tmp let-item="item"> <span class="ng-value-label"> {{
                                        item?.countryName }} </span> </ng-template>
                                <ng-template ng-notfound-tmp>
                                    <div class="no-items-found">
                                        <img src="assets/images/not-found.png" alt="No items found"
                                            class="no-items-image" />
                                        <p>No country found</p>
                                    </div>
                                </ng-template>
                            </ng-select>
                            <mat-error class="px-4"
                                *ngIf="addPassportForm.get('countryControl0')?.hasError('required') && addPassportForm.get('countryControl0')?.touched">
                                Country is required. </mat-error>
                            <mat-error
                                *ngIf="addPassportForm.get('countryControl0')?.hasError('InvalidInput') && addPassportForm.get('countryControl0')?.touched">
                                Please select valid nationality. </mat-error>
                        </div>

                        <div class="f-col">
                            <ng-select autoBlurSelect [items]="countriesLists" groupBy="group"
                                [searchFn]="_CommonService.customCountrySearchFn" formControlName="placeOfResidence"
                                bindValue="isoCode" placeholder="Place of recidence" (change)="changeCountry($event)">
                                <ng-template ng-optgroup-tmp let-item="item"> {{ item.group }} </ng-template>
                                <ng-template ng-option-tmp let-item="item">
                                    <span class="ng-option-label">
                                        <ng-container *ngIf="!!item?.newFlag?.src">
                                            <img [src]="getImageUrl(item?.newFlag?.src)"
                                                alt="Flag of {{ item.countryName }}" class="flag-img"
                                                [height]="item.height" [width]="item.width" />
                                        </ng-container>
                                        {{ item.countryName }}
                                    </span>
                                </ng-template>
                                <ng-template ng-label-tmp let-item="item">
                                    <span class="ng-value-label"> {{ item?.countryName }} </span>
                                </ng-template>
                                <ng-template ng-notfound-tmp>
                                    <div class="no-items-found">
                                        <img src="assets/images/not-found.png" alt="No items found"
                                            class="no-items-image" />
                                        <p>No country found</p>
                                    </div>
                                </ng-template>
                            </ng-select>
                            <mat-error class="px-4"
                                *ngIf="addPassportForm.get('placeOfResidence')?.hasError('required') && addPassportForm.get('placeOfResidence')?.touched">
                                Country is required. </mat-error>
                            <mat-error
                                *ngIf="addPassportForm.get('placeOfResidence')?.hasError('InvalidInput') && addPassportForm.get('placeOfResidence')?.touched">
                                Please select valid Country. </mat-error>
                        </div>


                    </div>

                    <div class="f-row two--ColLayout">
                        <div class="f-col">
                            <mat-form-field appearance="fill">
                                <mat-label>{{content?.['b2b.managetraveler.doctype']}}</mat-label>
                                <mat-icon fontSet="material-symbols-outlined" matSuffix>stat_minus_1</mat-icon>
                                <mat-select formControlName="DocType" (selectionChange)="onDocTypeChange($event.value)">
                                    <mat-option *ngFor="let type of _CommonService.documentTypes" [value]="type.value">
                                        {{ type.name }} </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="addPassportForm.get('DocType')?.hasError('required') && addPassportForm.get('DocType')?.touched">
                                    Document type is required. </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="f-row two--ColLayout">
                        <h3 class="h3-heading">
                            {{documentTypesObj[addPassportForm.getRawValue().DocType]?.heading}}
                        </h3>
                    </div>

                    <div class="f-row two--ColLayout">
                        <div class="f-col">
                            <mat-form-field appearance="fill">
                                <mat-label>{{documentTypesObj[addPassportForm.getRawValue().DocType]?.heading}}</mat-label>
                                <input matInput formControlName="Passportno" (keypress)="blockInvalidCharacters($event)"
                                    (paste)="_CommonService.onPasteBlocked($event)"
                                    (contextmenu)="_CommonService.disableRightClick($event)"
                                    (blur)="verifyDuplicateDocID()"
                                    >

                                <mat-error *ngIf="addPassportForm.get('Passportno')?.hasError('required')"> {{
                                    documentTypesObj[addPassportForm.getRawValue().DocType]?.heading }}
                                    is required. </mat-error>

                                <mat-error *ngIf="addPassportForm.get('Passportno')?.hasError('duplicatedoc')">
                                    Document number already exists.
                                </mat-error>

                                <mat-error *ngIf="addPassportForm.get('Passportno')?.hasError('pattern')">
                                    <ng-container [ngSwitch]="addPassportForm.get('DocType')?.value">
                                        <!-- TSA -->
                                        <ng-container *ngSwitchCase="'T'">
                                            TSA Precheck number must be exactly 9 digits.
                                        </ng-container>

                                        <!-- Redress -->
                                        <ng-container *ngSwitchCase="'R'">
                                            Redress number must be exactly 7 digits.
                                        </ng-container>

                                        <!-- National ID -->
                                        <ng-container *ngSwitchCase="'A'">
                                            National ID must be exactly 10 digits.
                                        </ng-container>

                                        <!-- IQAMA -->
                                        <ng-container *ngSwitchCase="'I'">
                                            IQAMA number must be exactly 10 digits.
                                        </ng-container>

                                        <!-- Passport -->
                                        <ng-container *ngSwitchCase="'P'">
                                            Passport number must be 6–12 characters long and contain only letters and
                                            numbers.
                                        </ng-container>
                                    </ng-container>
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="f-col position-relative c-position-right open-calendar-bottom"
                            *ngIf="!isPrecheckOrRedress"
                            [class.view-disabled]="!!(data?.personalInfo?.isElmVerified || data?.data?.personalInfo?.isElmVerified)">
                            <mat-form-field appearance="fill" (click)="showComponent0('isDOBCalendarVisible0')">
                                <mat-label>{{content?.['b2b.managetraveler.dob']}}</mat-label>
                                <input matInput formControlName="DOB"
                                    [value]="selectedDOB0 ? (selectedDOB0 | date: 'dd/MM/y') : ''" placeholder="DOB"
                                    autocomplete="off" (keypress)="_CommonService.blockInvalidCharactersForDOB($event)"
                                    (contextmenu)="_CommonService.disableRightClick($event)"
                                    (paste)="_CommonService.onPasteBlocked($event)" />
                                <mat-icon fontSet="material-symbols-outlined" matSuffix>calendar_today</mat-icon>
                                <mat-error
                                    *ngIf="addPassportForm.get('DOB')?.hasError('required') && addPassportForm.get('DOB')?.touched">
                                    Please select your date of birth. </mat-error>
                            </mat-form-field>
                            <app-date-ofbirth *ngIf="isChildVisible0['isDOBCalendarVisible0']"
                                [disabled]="isDisableDateOfBirth0" (confirm)="onConfirm0('isDOBCalendarVisible0')"
                                (dateSelected)="onDateSelected0($event)" [PassengerTypeCode]="'ADT'"
                                class="datepicker-content-container"> </app-date-ofbirth>
                        </div>
                    </div>
                    <div class="f-row two--ColLayout" *ngIf="!isPrecheckOrRedress">
                        <div class="f-col">
                            <ng-select autoBlurSelect [items]="countriesLists" groupBy="group"
                                [searchFn]="_CommonService.customCountrySearchFn" formControlName="issueCountry"
                                bindValue="isoCode" placeholder="Issue Country" (change)="changeCountry($event)">
                                <ng-template ng-optgroup-tmp let-item="item"> {{ item.group }} </ng-template>
                                <ng-template ng-option-tmp let-item="item">
                                    <span class="ng-option-label">
                                        <ng-container *ngIf="!!item?.newFlag?.src">
                                            <img [src]="getImageUrl(item?.newFlag?.src)"
                                                alt="Flag of {{ item.countryName }}" class="flag-img"
                                                [height]="item.height" [width]="item.width" />
                                        </ng-container>
                                        {{ item.countryName }}
                                    </span>
                                </ng-template>
                                <ng-template ng-label-tmp let-item="item">
                                    <span class="ng-value-label"> {{ item?.countryName }} </span>
                                </ng-template>
                                <ng-template ng-notfound-tmp>
                                    <div class="no-items-found">
                                        <img src="assets/images/not-found.png" alt="No items found"
                                            class="no-items-image" />
                                        <p>No country found</p>
                                    </div>
                                </ng-template>
                            </ng-select>
                            <mat-error class="px-4"
                                *ngIf="addPassportForm.get('issueCountry')?.hasError('required') && addPassportForm.get('issueCountry')?.touched">
                                Country is required. </mat-error>
                            <mat-error
                                *ngIf="addPassportForm.get('issueCountry')?.hasError('InvalidInput') && addPassportForm.get('issueCountry')?.touched">
                                Please select valid nationality. </mat-error>
                        </div>
                        <div class="f-col">
                            <ng-select autoBlurSelect [items]="commonObjPipes.cities" formControlName="passportPOI"
                                placeholder="Place of issue" bindLabel="cityName" bindValue="cityName"
                                (keypress)="_CommonService.blockInvalidCharacters($event)"
                                (paste)="_CommonService.onPasteBlocked($event)"
                                (contextmenu)="_CommonService.disableRightClick($event)"></ng-select>
                            <mat-error class="px-4"
                                *ngIf="addPassportForm.get('passportPOI')?.hasError('required') && addPassportForm.get('passportPOI')?.touched">
                                Place of issue is required. </mat-error>
                        </div>
                    </div>
                    <div class="f-row two--ColLayout" *ngIf="!isPrecheckOrRedress">
                        <div class="f-col position-relative open-calendar-bottom">
                            <mat-form-field appearance="fill" (click)="showComponent1('isDOBCalendarVisible1')">
                                <mat-label>{{content?.['b2b.managetraveler.validfrom']}} (Optional) </mat-label>
                                <input matInput formControlName="Validfromdate"
                                    placeholder="Select your valid from date"
                                    [value]="selectedValidateDate ? (selectedValidateDate | date:'dd/MM/y'): ''"
                                    autocomplete="off" (keypress)="blockInvalidCharactersForvaliddate($event)"
                                    (paste)="pasteControlHTMLTags($event)" readonly />
                                <mat-icon fontSet="material-symbols-outlined" matSuffix>calendar_today</mat-icon>
                                <mat-error
                                    *ngIf="addPassportForm.get('Validfromdate')?.hasError('required') && addPassportForm.get('Validfromdate')?.touched">
                                    Please select your valid from. </mat-error>
                            </mat-form-field>
                            <!-- <app-expiry-date *ngIf="isChildVisible1['isDOBCalendarVisible1']" (confirm)="onConfirm1('isDOBCalendarVisible1')" [filledDate]="selectedValidateDate ? (selectedValidateDate | date:'dd/MM/y') : this.addPassportForm.value.Validfromdate" [key]="'isDOBCalendarVisible1'" [passengerTravelerCode]="'ADT'" [bypassDate]="true" (dateSelected)="onDateSelected1($event,'isDOBCalendarVisible1')"> </app-expiry-date> -->
                            <app-date-ofbirth *ngIf="isChildVisible1['isDOBCalendarVisible1']"
                                (confirm)="onConfirm1('isDOBCalendarVisible1')"
                                (dateSelected)="onDateSelected1($event,'isDOBCalendarVisible1')"
                                [selectedDOBDateFromParent]="selectedDOB0" [key]="'isDOBCalendarVisible1'"
                                [PassengerTypeCode]="'ADT'" class="datepicker-content-container" [position]="-140">
                            </app-date-ofbirth>
                        </div>
                        <div class="f-col position-relative c-position-right open-calendar-bottom">
                            <mat-form-field appearance="fill" (click)="showComponent2('isDOBCalendarVisible2')">
                                <mat-label>{{content?.['b2b.managetraveler.expirydate']}}</mat-label>
                                <input matInput formControlName="ExpiryDate" placeholder="Select your expiry date"
                                    [value]="selectedExpiryDate ? (selectedExpiryDate | date:'dd/MM/y') : ''"
                                    autocomplete="off" (keypress)="blockInvalidCharactersForExpiryDate($event)"
                                    (paste)="pasteControlHTMLTags($event)" readonly />
                                <mat-icon fontSet="material-symbols-outlined" matSuffix>calendar_today</mat-icon>
                                <mat-error
                                    *ngIf="addPassportForm.get('ExpiryDate')?.hasError('required') && addPassportForm.get('ExpiryDate')?.touched">
                                    Please select your valid from. </mat-error>
                            </mat-form-field>
                            <!-- <app-expiry-data-calendar *ngIf="isChildVisible2['isDOBCalendarVisible2']" [AddOnMonths]="0" (confirm)="onConfirm2('isDOBCalendarVisible2')" [minimumDate]="addPassportForm.value.Validfromdate" [filledDate]="selectedExpiryDate ? (selectedExpiryDate | date:'dd/MM/y') : this.addPassportForm.value.ExpiryDate" [passengerTravelerCode]="'ADT'"  (dateSelected)="onDateSelected2($event,'isDOBCalendarVisible2')"> </app-expiry-data-calendar> -->
                            <app-expiry-date *ngIf="isChildVisible2['isDOBCalendarVisible2']"
                                (confirm)="onConfirm2('isDOBCalendarVisible2')"
                                [filledDate]="selectedExpiryDate ? (selectedExpiryDate | date: 'dd/MM/y') : ''"
                                [key]="'isDOBCalendarVisible2'" [passengerTravelerCode]="'ADT'" [bypassDate]="false"
                                (dateSelected)="onDateSelected2($event,'isDOBCalendarVisible2')">
                            </app-expiry-date>
                        </div>
                    </div>
                </div>
            </div>

            <div class="f-col d-align-right verify-footer"
                *ngIf="this.data.edit">
                <button mat-button class="button--primary-small" [class.disabled]="addPassportForm.invalid || !hasFormChanged() || Loader.isSpinner" (click)="onSave()">
                    <mat-spinner class="button" *ngIf="Loader.isSpinner"></mat-spinner>
                    Save</button>
            </div>

            <!-- <div class="f-col d-align-right verify-footer">
                <button mat-button class="button--primary-small" [class.disabled]="addPassportForm.invalid"
                    (click)="onSave()" *ngIf="this.data.edit"> {{content?.['b2b.managetraveler.save']}} </button>
            </div> -->
        </div>
    </div>
</form>

<ng-template #selectionWarning>
    <div class="custom-popup-gen-container">

        <!-- Header -->
        <div class="custom-popup-gen-header">
            <span>
                {{ content?.['b2b.managetraveler.namemismatch'] || 'Name mismatch' }}
            </span>

            <mat-icon fontSet="material-symbols-outlined" class="close_icon" tabindex="0" role="button"
                aria-label="close dialog" (keyup.space)="CloseWarning(false)" (keydown.enter)="CloseWarning(false)"
                (click)="CloseWarning(false)">
                close
            </mat-icon>
        </div>

        <!-- Body -->
        <div class="custom-popup-gen-body">

            <p>
                {{
                content?.['b2b.managetraveler.profilenamedifffromdoc']
                || "Your profile name is different from the document. If you continue we'll update as per document"
                }}
            </p>

            <div class="custom-popup-gen-name-details">

                <div class="custom-popup-gen-name-row">
                    <span>
                        {{
                        content?.['b2b.managetraveler.nameonprofile']
                        || 'Name on profile'
                        }} -
                    </span>

                    <span data-dd-privacy="mask">
                        {{ profileName }}
                    </span>
                </div>

                <div class="custom-popup-gen-name-row">
                    <span>
                        {{
                        content?.['b2b.managetraveler.nameondoc']
                        || 'Name on document'
                        }} -
                    </span>

                    <span data-dd-privacy="mask">
                        {{ docName }}
                    </span>
                </div>

            </div>

        </div>

        <!-- Footer -->
        <div class="custom-popup-gen-footer">

            <button class="button--secondary-small" mat-button type="button" (click)="CloseWarning(false)">
                {{
                content?.['b2b.managetraveler.cancel']
                || 'Cancel'
                }}
            </button>

            <button class="button--primary-small mx-0" mat-button type="button" [disabled]="Loader.isSpinner"
                (click)="onContinueAfterMismatch()">

                {{
                content?.['b2b.managetraveler.continue']
                || 'Continue'
                }}

                <mat-spinner class="button" *ngIf="Loader.isSpinner">
                </mat-spinner>

            </button>

        </div>

    </div>
</ng-template>
